// extracted by mini-css-extract-plugin
export default {"LogoDIv":"TermsOf_LogoDIv__uuCoA","LogImg":"TermsOf_LogImg__b2sNM","mainPriva":"TermsOf_mainPriva__AGnwT","paraStart":"TermsOf_paraStart__PN-3d","DivBold":"TermsOf_DivBold__KZfbz"};